module.exports = __webpack_public_path__ + "img/warn-icon.871cdbce.png";